
const m = window.require("tooltip.js");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;
